var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCubismOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "overlapping_off") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 16,
    height: 16,
    rx: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "overlapping_off",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(7.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#74797D",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-5",
    fill: "#FFFFFF",
    opacity: 0.200000003,
    mask: "url(#mask-2)",
    points: "6.22222222 0.888888889 15.1111111 0.888888889 15.1111111 15.1111111 1.77777778 15.1111111"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-5",
    fill: "#FFFFFF",
    opacity: 0.400000006,
    mask: "url(#mask-2)",
    points: "15.1111111 0.888888889 15.1111111 15.1111111 6.22222222 15.1111111 10.6666667 0.888888889"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-5",
    fill: "#FFFFFF",
    opacity: 0.800000012,
    mask: "url(#mask-2)",
    points: "15.1111111 0.888888889 15.1111111 15.1111111 10.6666667 15.1111111"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#74797D",
    mask: "url(#mask-2)",
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCubismOff);
export default __webpack_public_path__ + "static/media/cubism-off.e186125d82453a0360d854652f046aa9.svg";
export { ForwardRef as ReactComponent };